+function ($){
    "use strict";
    var gallery_grid = $('#gallery_grid'),
        pswpFolder = gallery_grid.data('pswp-folder') || '',
        viewer = gallery_grid.find('.grid-item'),
        items = [];

    if(viewer.length){
        items = $.map( viewer, function( item, i ) {
            item = $(item);
            var itemObj = {
                src: pswpFolder + '/' + item.data('pswp-src'),
                w: item.data('pswp-width'),
                h: item.data('pswp-height'),
            }
            var title = item.data('pswp-title'),
                h5 = title.length ? '<h5>'+title+'</h5>' : null;

            var description = item.find('.description'),
                text = description.length ? '<div class="caption">'+description.html()+"</div>" : 0,
                caption = text.length ? text : null;

            if(caption){
                h5 = h5 ? h5 + caption : caption;
            }

            if(h5){
                itemObj.title = h5;
            }

            return itemObj;
        });
    }

    if(items.length){
        var clickedIndex=0,
            pswpElement = document.querySelectorAll('.pswp')[0],
            gBtn = gallery_grid.find('.info'),
            gOptions = {
                barsSize: {top:44, bottom:'auto'},
                history:false,
                closeEl:true,
                captionEl: true,
                fullscreenEl: true,
                zoomEl: true,
                shareEl: false,
                counterEl: true,
                arrowEl: true,
                preloaderEl: true,
                tapToClose: false,
                tapToToggleControls: true,
                clickToCloseNonZoomable: true,
                indexIndicatorSep: ' / ',
                showHideOpacity:true,
                getThumbBoundsFn:false,
                // getThumbBoundsFn: function(index) {
                //     var clickedInfo = $( "a.info[data-pswp-index='"+index+"']" ),
                //         parent = clickedInfo.closest('.grid-item'),
                //         thumbnail = clickedInfo.closest('.grid-item').find('img')[0],
                //         pageYScroll = window.pageYOffset || document.documentElement.scrollTop
                //         ,rect = thumbnail.getBoundingClientRect();
                //     // console.log(thumbnail);
                //
                //     return {x:rect.left, y:rect.top + pageYScroll, w:parent.outerWidth()*1.5};
                //
                // }

            };

        gBtn.on('click', function (e) {
            clickedIndex = $(this).data('pswp-index');
            // console.log(clickedIndex);

            openPhotoSwipe( clickedIndex );

        });

        var openPhotoSwipe = function(index, disableAnimation) {

            // gOptions.index = parseInt(index, 10);
            gOptions.index = index ? index : 0;

            if(disableAnimation) {
                gOptions.showAnimationDuration = 0;
            }

            viewer = new PhotoSwipe( pswpElement , PhotoSwipeUI_Default, items, gOptions);

            // see: http://photoswipe.com/documentation/responsive-images.html
            var realViewportWidth,
                useLargeImages = false,
                firstResize = true,
                imageSrcWillChange;

            viewer.listen('beforeResize', function() {

                var dpiRatio = window.devicePixelRatio ? window.devicePixelRatio : 1;
                dpiRatio = Math.min(dpiRatio, 2.5);
                realViewportWidth = viewer.viewportSize.x * dpiRatio;


                if(realViewportWidth >= 1200 || (!viewer.likelyTouchDevice && realViewportWidth > 800) || screen.width > 1200 ) {
                    if(!useLargeImages) {
                        useLargeImages = true;
                        imageSrcWillChange = true;
                    }

                } else {
                    if(useLargeImages) {
                        useLargeImages = false;
                        imageSrcWillChange = true;
                    }
                }

                if(imageSrcWillChange && !firstResize) {
                    viewer.invalidateCurrItems();
                }

                if(firstResize) {
                    firstResize = false;
                }

                imageSrcWillChange = false;

            });


            viewer.init();
        };//end openPhotoSwipe

    }//end if items.length
}(jQuery);
